export const environmentBase = {
  TSI_CONFIGURACION: 'url_configuracion',
  TSI_CONFIGURACION_PRUEBA: 'url_configuracion',
  TSI_PLANILLA: 'url_planilla',
  TSI_PLANILLA_PRUEBA: 'url_planilla',
  TSI_DECLARACIONES_TRIBUTOS: 'url_declaraciones_tributos',
  TSI_DECLARACIONES_TRIBUTOS_PRUEBA: 'url_declaraciones_tributos',
  TSI_PROD: 'url_prod',
  TSI_PROD_PRUEBA: 'url_prod',
  TSI_SOPORTE:'url_soporte',
  TSI_SOPORTE_PRUEBA:'url_soporte',
  TSI_IMPORTACIONES: 'url_importaciones',
  TSI_IMPORTACIONES_PRUEBA: 'url_importaciones',
  TSI_RENDICIONES: "url_rendiciones",
  TSI_RENDICIONES_PRUEBA: "url_rendiciones",
  TSI_ACTIVOS: 'url_activos',
  TSI_ACTIVOS_PRUEBA: 'url_activos',
  TSI_PUNTO_VENTA: 'url_punto_venta',
  TSI_PUNTO_VENTA_PRUEBA: 'url_punto_venta',
  TSI_HERRAMIENTAS: 'url_herramientas',
  TSI_HERRAMIENTAS_PRUEBA: 'url_herramientas',
  NEW_TSI_APP: 'url_new_erp_app',
  NEW_TSI_APP_PRUEBA: 'url_new_erp_app'
}